import React from "react";
import {Col, Container, Image, Row} from "react-bootstrap";
import {Buy} from "../mint/buy";
import "./about.scss";

import ElfBanner01 from "../../assets/elf/banner/wallpaper-Elf-01.png";
import ElfBanner02 from "../../assets/elf/banner/wallpaper-Elf-02.png";
import ElfBanner03 from "../../assets/elf/banner/wallpaper-Elf-03.png";
import ElfBanner04 from "../../assets/elf/banner/wallpaper-Elf-04.png";

import ElfPremint from "../../assets/elf/elf-premint.png";

// TODO: Add # ID attribute for About page nav

export const About = () => {
    const fields = [];
    for (let i = 1; i <= 32; i++) {
        fields.push(
            <div className="circle-container">
                <div className="circle"></div>
            </div>
        );
    }
    return (
        <>
            <Container fluid className="raining raining-top">
                <Row className="elf-banner elf-banner-top justify-content-center">
                    <Image src={ElfBanner01} className="elf-banner-layer animate-01"/>
                    <Image src={ElfBanner02} className="elf-banner-layer animate-02"/>
                    <Image src={ElfBanner03} className="elf-banner-layer animate-03"/>
                    <Image src={ElfBanner04} className="elf-banner-layer animate-04"/>
                </Row>
            </Container>
            <Container fluid className="raining">
                <Row className="elf-banner-title justify-content-center">
                    <Col md={8}>
                        <h1 className="px-5 pt-0 pb-5 text-center new-font mt-2">All I want for Christmas is
                            one of the 7777 unique elves.</h1>
                    </Col>
                </Row>
                <Container fluid className="elf-banner-content rounded-3">
                    <Row className="justify-content-center">
                        <Col md={10} id="about">
                            <br className="my-2"/>
                            <h2 className="new-font" mb-3>Why an Elf?</h2>
                            <p>Because Santa can’t do his job without his little helpers.</p>
                            <p>This Christmas we (SolPhantoms) would like to spread joy and happiness to people a little
                                differently. As this year the elves won’t be boxing toys and tangible gifts. However,
                                they
                                will be busy packing something else, they will be filling the gift boxes with hope for
                                the
                                people. The kind of hope that builds bridges for a better tomorrow. The hovering Sol
                                Phantoms wanted to have Jusoor as their first friend in this journey.
                            </p>
                            <br className="my-2"/>
                            <h2 className="new-font" my-3>How the ElfNFT supports education?</h2>
                            <p>
                                Jusoor was born in the first year of the Syrian crisis (2011), with a global mission to
                                facilitate quality education for young Syrians around the world and teach them the
                                know-how
                                to be great individuals.
                            </p>
                            <p>
                                These are the types of gifts that give real hope to the people who need it most, gifts
                                that
                                change the world.
                            </p>
                        </Col>
                    </Row>
                </Container>
                {fields}
            </Container>

            <Container fluid id="mint" className="mint-section mh-100 h-100 d-block py-5">
                <Row className="py-3">
                    <Col md={{span: 5, offset: 1}} className="text-center">
                        <Image fluid src={ElfPremint} width="450"/>
                    </Col>
                    <Col md={4} className="justify-content-center text-center">
                        <br className="my-5"/>
                        <h2>Mint your ElfNFT</h2>
                        <p>You can mint one elf per transaction. You can have as many transactions as you want, <i>before the elves sell out</i>. </p>
                        <p>Minting price is 0.7777 SOL <i>plus transaction fees</i> </p>
                        <p>Want to be whitelisted for a <i><b>0.5 SOL</b> discounted mint</i>? <a href="https://discord.gg/xzBxjf5yMS" target="_blank" rel="external">Ask how on Discord</a></p>
                        {/*<Button variant="secondary" className="disabled rounded-pill">Mint not started</Button>*/}
                        <Buy/>

                    </Col>
                </Row>

            </Container>

        </>
    );
};